import React from "react";
import { Link } from "react-router-dom";

function ChooseASimulation() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-Choose-a-simulation">
      <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
            <div className="row d-flex justify-content-center align-items-center my-auto text-center w-75">
                <div className="bg-white py-3 rounded-pill border border-4 border-dark mb-3 shadow">
                    <p className="heading-font mb-0">Choose a Simulation</p>
                </div>
                <Link  to={'/investing-in-real-estate'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Investing in Real Estate (First Time? Start Here)
                </Link>
                <Link  to={'/personalize-simulation'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Personalize Simulation
                </Link>
                <Link  to={'#'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                More Simulations Coming Soon...
                </Link>
                {/* <Link  to={'/lending-money'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Lending Money
                </Link> */}
                {/* <Link  to={'/'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Saving Money in the Bank
                </Link>
                <Link  to={'/'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Investing in Mutual Funds/Stocks/Bonds
                </Link>
                <Link  to={'/'} className="btn btn-primary btn-lg px-5 inner-shadow w-75 mt-2">
                Paying Cash for Everything
                </Link> */}
                {/* <div  data-aos="fade-up" data-aos-anchor-placement="top-bottom" className="btn btn-lg px-5 inner-shadow w-100 mt-5">
                If multiple choices apply to you, choose one. You can come back and choose another later.
                </div> */}
            </div>
        </div>
      </div>
    </>
  );
}

export default ChooseASimulation;
